export const externalIntegrationsApiHandler = {
  internalHimamUse: {
    createApiKey: {
      method: "POST",
      path: () => `external-integrations/create-key`
    },
    updateApiKey: {
      method: "POST",
      path: () => `external-integrations/update-key`
    }
  },
  externalHimamUse: {
    createUser: {
      method: "POST",
      path: () => `external-integrations-api/create-user`
    }
  },
  clickup: {
    getListTasks: {
      method: "GET",
      path: (payload: { listid: string | number }) => `external-integrations/clickup/lists/${payload.listid}/tasks`,
      params: {} as {'include_closed'?: string | number}
    },
    createTask: {
      method: "POST",
      path: (payload: { listid: string | number }) => `external-integrations/clickup/lists/${payload.listid}/tasks`
    },
    getTaskDetails: {
      method: "GET",
      path: (payload: { taskId: string | number }) => `external-integrations/clickup/tasks/${payload.taskId}`
    },
    updateTaskStatus: {
      method: "PATCH",
      path: (payload: { taskId: string | number }) => `external-integrations/clickup/tasks/${payload.taskId}/status`
    },
    addCommentToTask: {
      method: "POST",
      path: (payload: { taskId: string | number }) => `external-integrations/clickup/tasks/${payload.taskId}/comments`
    }
  }
};